export const Constants = {
  start: 'Início',
  constructionList: 'Lista de Obras',
  editConstruction: 'Editar Obra',
  changePicture: 'trocar imagem',
  deleteConstruction: 'excluir obra',
  cancel: 'cancelar',
  save: 'salvar',
};
